module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g9Xqx"))).then(() => parcelRequire('hEqeo'));